import * as React from "react";

import axios from "axios";
import FileDownload from "js-file-download";

import { HotKeys } from "react-hotkeys";

import { endOfWeek, startOfWeek } from "date-fns";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";

import { createMuiTheme, withStyles } from "@material-ui/core/styles";

import { kAllMetadata, kClaimMetadata, kPatientMetadata, kPractitionerMetadata, kClaimResponseMetadata } from "../../Components/Common";
import { parse } from "date-fns";

import { withData } from "../../Components/withData";

import Filter from "../../Components/Filter";
import WeekPicker from "../../Components/WeekPicker";
import { getClaimLoadCriteria } from "../../utils/claimLoadCriteria";

const kMetadata = {
  Claim: kClaimMetadata,
  Practitioner: kPractitionerMetadata,
  Patient: kPatientMetadata,
  ClaimResponses: kClaimResponseMetadata,
};

const kFilterKinds = [
  {
    id: 'inc',
    filter: (value: any, arg1: any) => String(value).includes(arg1)
  },
  {
    id: 'notinc',
    filter: (value: any, arg1: any) => !String(value).includes(arg1)
  },
  {
    id: 'eq',
    filter: (value: any, arg1: any) => value === arg1
  },
  {
    id: 'ne',
    filter: (value: any, arg1: any) => value !== arg1
  },
  {
    id: 'lt',
    filter: (value: any, arg1: any) => value < arg1
  },
  {
    id: 'gt',
    filter: (value: any, arg1: any) => value > arg1
  },
  {
    id: 'btwn',
    filter: (value: any, arg1: any, arg2: any) => value > arg1 && value < arg2
  },
];

const styles = (theme: any) => ({
  paper: {
    paddingBottom: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "16px",
  },
  patient_name: {
    minWidth: "140px",
  },
  section: {
    paddingBottom: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "16px",
  },
  table: {
    paddingBottom: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "16px",
  },
  title: {
    paddingBottom: "32px",
  },
  summaryReportButton: {
    display: "flex",
  },
  warning: {
    display: "flex",
    padding: "8px",
    alignItems: "center",
    backgroundColor: "rgb(255, 244, 229)",
  },
});

class ReportPage extends React.Component<any, any> {
  private keyHandlers = {};

  public constructor(props: any) {
    super(props);

    this.state = {
      reportLoading: false,
      selectedDate: new Date(),
      selectedPractitioner: -1,
      claimsLoading: false,
      snackbar: {
        isOpen: false,
        message: "",
      },
      fileFormat: "pdf",
    };
  }

  public componentDidMount() {
    this.ensureClaimsLoaded();
  }

  public componentDidUpdate(prevProps: any) {
    if (this.state.claimsLoading &&
        prevProps.claimEndpoint.data !== this.props.claimEndpoint.data &&
        this.hasClaimsLoaded()) {
      this.setState({ claimsLoading: false });
    }
  }

  public componentWillMount() {
    const { practitionerEndpoint } = this.props;
    const practitioners = practitionerEndpoint.data.sort((a: any, b: any) => {
      return a.practitioner_name < b.practitioner_name ? -1 : 1;
    });
    this.setState({
      selectedPractitioner: practitioners[0].practitioner_id,
    });
  }

  public render() {
    const { classes } = this.props;

    const isCSV = this.state.fileFormat === "csv";
    const canUseCsv = !!this.props.isSuperUser;

    return (
      <HotKeys handlers={this.keyHandlers} focused={true} attach={window}>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.snackbar.isOpen}
          autoHideDuration={5000}
          onClose={this.handleSnackbarClose}
          message={this.state.snackbar.message}
          action={
            <IconButton
              aria-label="Close"
              color="inherit"
              onClick={this.handleSnackbarClose}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <Grid container={true}>
          <Grid item={true} md={12} className={classes.section}>
            <Paper className={classes.paper}>
              <FormControl>
                <FormLabel>File Format</FormLabel>
                <RadioGroup
                  row={true}
                  name="fileFormat"
                  value={this.state.fileFormat}
                  onChange={this.onFileFormatChange}
                >
                  <FormControlLabel
                    value="pdf"
                    control={<Radio />}
                    label="PDF"
                  />
                  {canUseCsv && (
                    <FormControlLabel
                      value="csv"
                      control={<Radio />}
                      label="CSV"
                    />
                  )}
                </RadioGroup>
              </FormControl>
            </Paper>
          </Grid>
          <Grid item={true} md={12} className={classes.section}>
            <Paper className={classes.paper}>
              <WeekPicker
                date={this.state.selectedDate}
                onWeekChange={this.onWeekChange}
              />
              <Button
                onClick={this.getOnGenerateReport(false)}
                disabled={this.state.reportLoading || this.state.claimsLoading || !this.hasClaimsLoaded()}
              >
                Generate Full Report
              </Button>
              <br />
              <div className={classes.summaryReportButton}>
                <Button
                  onClick={this.getOnGenerateReport(true)}
                  disabled={isCSV || this.state.reportLoading || this.state.claimsLoading || !this.hasClaimsLoaded()}
                >
                  Generate Summary Report
                </Button>
                {isCSV && (
                  <Paper className={classes.warning}>
                    <WarningIcon />
                    <div>Summary Reports are not available in CSV format</div>
                  </Paper>
                )}
              </div>
            </Paper>
          </Grid>
          <Grid item={true} md={12} className={classes.section}>
            <Paper className={classes.paper}>
              <Filter
                onApply={this.onGenerateFilteredReport}
                applyButtonText={"Generate Filtered Report"}
              />
              {(this.state.reportLoading || this.state.claimsLoading) && (
                <Grid container={true} justify="center">
                  <CircularProgress size={32} />
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      </HotKeys>
    );
  }

  private onWeekChange = (date: any) => {
    this.setState({
      selectedDate: date,
    });
  };

  private onFileFormatChange = (event: any) => {
    const nextFormat = event.target.value;
    if (!this.props.isSuperUser && nextFormat === "csv") {
      this.openSnackbar("CSV export is available only for admin users.");
      this.setState({ fileFormat: "pdf" });
      return;
    }

    this.setState({
      fileFormat: nextFormat,
    });
  };

  private getAcceptHeader = () => {
    return this.state.fileFormat === "csv" ? "text/csv" : "application/pdf";
  };

  private hasClaimsLoaded = () => {
    const { claimEndpoint } = this.props;
    return claimEndpoint &&
      Array.isArray(claimEndpoint.data) &&
      claimEndpoint.data.length > 0;
  };

  private getLoadCriteria = () => {
    return getClaimLoadCriteria();
  };

  private ensureClaimsLoaded = () => {
    if (this.hasClaimsLoaded()) {
      return;
    }

    if (this.props.claimEndpoint && typeof this.props.claimEndpoint.action === "function") {
      this.setState({ claimsLoading: true });
      this.props.claimEndpoint.action(this.getLoadCriteria(), "load");
    }
  };

  private getClaimIds = () => {
    if (!this.hasClaimsLoaded()) {
      return [];
    }

    return this.props.claimEndpoint.data
      .map((claim: any) => parseInt(claim.claim_id, 10))
      .filter((id: number) => Number.isFinite(id));
  };

  private applyFiltersToClaims = (claims: any[], filters: any[]) => {
    if (!Array.isArray(filters) || filters.length === 0) {
      return claims;
    }

    return claims.filter((claim: any) => {
      const filterFunc = (filter: any) => {
        const metadataGroup = kMetadata[filter.subobj as keyof typeof kMetadata];
        if (!metadataGroup) {
          return true; // If metadata group not found, don't filter out
        }
        
        const fieldMetadata = metadataGroup.find((m: any) => m.name === filter.name);
        if (!fieldMetadata) {
          return true; // If metadata not found, don't filter out
        }

        let data = fieldMetadata.fromClaim(claim);
        if (fieldMetadata.type === 'date') {
          // Parse date data from claim (format: MM-dd-yyyy) - matches ReviewClaims
          data = parse(data, 'MM-dd-yyyy', new Date());
          
          // Normalize to date only (set time to midnight) for consistent comparison
          const normalizeDate = (date: Date) => {
            const normalized = new Date(date);
            normalized.setHours(0, 0, 0, 0);
            return normalized;
          };
          data = normalizeDate(data);
          
          // Convert filter args to Date objects for proper comparison
          // Filter component sends dates as 'yyyy-MM-dd' strings, but ReviewClaims uses Date objects
          let arg1: any = filter.arg1;
          let arg2: any = filter.arg2;
          
          // Convert arg1 to Date if it's a string
          if (typeof arg1 === 'string') {
            // Filter component sends 'yyyy-MM-dd' format
            arg1 = new Date(arg1);
            if (isNaN(arg1.getTime())) {
              // If parsing fails, try to handle it gracefully
              return true;
            }
            arg1 = normalizeDate(arg1);
          } else if (arg1 instanceof Date) {
            // Already a Date object (shouldn't happen from Filter component, but handle it)
            arg1 = normalizeDate(arg1);
          }
          
          // Convert arg2 to Date if it's a string
          if (arg2) {
            if (typeof arg2 === 'string') {
              arg2 = new Date(arg2);
              if (isNaN(arg2.getTime())) {
                arg2 = null;
              } else {
                arg2 = normalizeDate(arg2);
              }
            } else if (arg2 instanceof Date) {
              arg2 = normalizeDate(arg2);
            }
          }
          
          const filterKind = kFilterKinds.find((k: any) => k.id === filter.type);
          if (!filterKind) {
            return true;
          }
          return filterKind.filter(data, arg1, arg2);
        } else {
          // For non-date fields, use filter args directly - matches ReviewClaims
          const filterKind = kFilterKinds.find((k: any) => k.id === filter.type);
          if (!filterKind) {
            return true;
          }
          return filterKind.filter(data, filter.arg1, filter.arg2);
        }
      };

      return filters.every(filterFunc);
    });
  };

  private getOnPractitionerChange() {
    return (event: any) => {
      this.setState({
        selectedPractitioner: parseInt(event.target.value, 10),
      });
    };
  }

  private getOnGenerateReport = (isSummary: boolean) => {
    return () => {
      const claimIds = this.getClaimIds();
      if (claimIds.length === 0) {
        this.openSnackbar("No claims loaded. Please load claims before generating a report.");
        return;
      }

      const loadCriteria = this.getLoadCriteria();
      this.setState({ reportLoading: true });
      axios
        .post(
          "/api/v1/get_report",
          {
            endDate: endOfWeek(this.state.selectedDate),
            fileFormat: this.state.fileFormat,
            isSummary,
            reportType: "weekly",
            startDate: startOfWeek(this.state.selectedDate),
            loadCriteria,
          },
          {
            headers: {
              Accept: this.getAcceptHeader(),
              "Content-Type": "application/json",
            },
            responseType: "blob",
          }
        )
        .then((response: any) => {
          FileDownload(response.data, "report." + this.state.fileFormat);
        })
        .catch((err: any) => {
          if (err.response.status === 503) {
            this.openSnackbar("Server is busy, please wait and try again");
          } else {
            this.openSnackbar("Error Generating Report");
          }
        })
        .finally(() => {
          this.setState({ reportLoading: false });
        });
    };
  };

  private onGenerateFilteredReport = (filters: any) => {
    if (!this.hasClaimsLoaded()) {
      this.openSnackbar("No claims loaded. Please load claims before generating a report.");
      return;
    }

    // Apply filters client-side to the loaded claims
    const loadedClaims = this.props.claimEndpoint.data || [];
    const filteredClaims = this.applyFiltersToClaims(loadedClaims, filters);
    
    if (filteredClaims.length === 0) {
      this.openSnackbar("No claims match the selected filters.");
      return;
    }

    // Extract claim IDs from filtered claims
    const filteredClaimIds = filteredClaims
      .map((claim: any) => parseInt(claim.claim_id, 10))
      .filter((id: number) => Number.isFinite(id));

    this.setState({ reportLoading: true });
    axios
      .post(
        "/api/v1/get_filtered_report",
        {
          fileFormat: this.state.fileFormat,
          claim_ids: filteredClaimIds,
        },
        {
        headers: {
          Accept: this.getAcceptHeader(),
          "Content-Type": "application/json",
        },
          responseType: "blob",
        }
      )
      .then((response: any) => {
        FileDownload(response.data, "report." + this.state.fileFormat);
      })
      .catch((err: any) => {
        if (err.response && err.response.status === 400) {
          this.openSnackbar("Filters are too broad");
        } else if (err.response && err.response.status === 503) {
          this.openSnackbar("Server is busy, please wait and try again");
        } else {
          this.openSnackbar("Error Generating Report");
        }
      })
      .finally(() => {
        this.setState({ reportLoading: false });
      });
  };

  private openSnackbar = (message: string) => {
    this.setState({
      snackbar: {
        isOpen: true,
        message: message,
      },
    });
  };

  private handleSnackbarClose = () => {
    this.setState({
      snackbar: {
        isOpen: false,
        message: "",
      },
    });
  };
}

export default withStyles(styles)(withData(ReportPage));
